module.exports = {
  googleMapsKey: 'AIzaSyBFsqKHb0VTePI3PhoIKI-mIXl2FyHAOMw'
}
